import { http } from 'services';

export function getCategories(type, id, section, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/categories/${section}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function saveCategories(type, id, section, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/categories/${section}`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}




// WEBPACK FOOTER //
// ./src/api/api-stuff-to-do/api-stuff-to-do-categories.js